<template>
  <div class="links">
    <div style="padding: 0 21px">
      <div class="home2-title">友情链接</div>
    </div>
    <div class="links-content">
      <swiper ref="mySwiper" :options="swiperOptions">
        <swiper-slide v-for="(item,index) of list" :key="index">
          <div class="links-card">
            <a :href="item2.href" v-for="(item2,index2) of item" :key="index2" target="_blank">
              <img :src="item2.img" alt="" />
            </a>
          </div>
        </swiper-slide>
        <!-- <div class="swiper-pagination" slot="pagination"></div> -->
        <div class="swiper-button-prev nav-btn" slot="button-prev"></div>
        <div class="swiper-button-next nav-btn" slot="button-next"></div>
      </swiper>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
export default {
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
      let base = '../../../../static/home2.0/url/'
    return {
      swiperOptions: {
            autoplay:true,
        pagination: {
          //   el: ".swiper-pagination", //与slot="pagination"处 class 一致
          clickable: true, //轮播按钮支持点击
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      list:[
          [
              {href:'http://zwfw.hubei.gov.cn/',img:base+'1-1.png'},
              {href:'http://admin.zhujianpeixun.com/',img:base+'1-2.png'},
              {href:'http://zjt.hubei.gov.cn/bsfw/wyc/zzzg/index.shtml',img:base+'1-3.png'},
              {href:'https://www.eanguan.com/login',img:base+'1-4.png'},
              {href:'http://113.57.190.85:8002/',img:base+'1-5.png'},
              // {href:'http://hbcj.enterprise.eceping.net/#/home',img:base+'1-6.png'},
              // {href:'http://hzym.enterprise.eceping.net/#/home',img:base+'1-7.png'},
              // {href:'http://hbhc.e.eceping.net/#/home',img:base+'1-8.png'},
              // {href:'http://zx.enterprise.eceping.net/#/home',img:base+'1-9.png'},
              // {href:'http://as.e.eceping.net/#/home',img:base+'1-10.png'},
          ],
          [
              {href:'http://www.mohrss.gov.cn/',img:base+'2-1.png'},
              {href:'https://www.mohurd.gov.cn/',img:base+'2-2.png'},
              {href:'http://jzgr.mohurd.gov.cn/',img:base+'2-3.png'},
              {href:'http://www.zgjzy.org.cn/menu_73.html',img:base+'2-4.png'},
              {href:'http://www.cacem.com.cn/',img:base+'2-5.png'},
              {href:'http://www.zhjzbs.com/',img:base+'2-6.png'},
              {href:'http://www.moe.gov.cn/',img:base+'2-7.png'},
              {href:'https://www.acftu.org/',img:base+'2-8.png'},
          ],
          [
              {href:'http://www.mwr.gov.cn/',img:base+'3-1.png'},
              {href:'http://slt.hubei.gov.cn/',img:base+'3-2.png'},
              {href:'http://www.cwec.org.cn/',img:base+'3-3.png'},
              {href:'http://jyt.hubei.gov.cn/',img:base+'3-4.png'},
              {href:'http://www.moe.gov.cn/',img:base+'3-5.png'},
          ]
      ],
    };
  },
};
</script>


<style lang="less"  src="./public.less" scoped></style>
<style lang="less" scoped>
.links {
  width: 1200px;
  margin: 20px auto 0;
  box-sizing: border-box;
  background: #fff;
  .home2-title {
    background-image: url("../../../../static/home2.0/icon-process.png");
  }
  .links-content {
    padding: 70px 10px;
    .links-card {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-wrap: wrap;
      text-align: center;
      height: 260px;
      img{
          &:hover{
              border-bottom: 2px solid #3482FF;
          }
      }
    }
    .nav-btn{
        width: 46px;
        height: 46px;
        border-radius: 50%;
        background: rgba(0,0,0,0.2);
        color: #fff;
        font-size: 12px;
        transition: all 0.3s;
        &:after{
            font-size: 16px;
        }
        &:hover{
            background: #2590F4;
        }
        &.swiper-button-prev{
            left: 0;
        }
        &.swiper-button-next{
            right: 0;
        }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Home3.0/src/Links.vue